<!-- @format -->
@if (showCompare()) {
	<div [class]="wrapperClasses()">
		<div class="hmf-header-bold-l hmf-p-s">Compare Similar Items</div>
		<compare-components-compare-grid
			[compareBarProducts]="compareBarProducts()"
			[compareProductDetails]="compareProductDetails()"
			[compareGridLoading]="false"
			[compareGridApiFailed]="false"
			location="PDP">
		</compare-components-compare-grid>
	</div>
}
